var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPurplehouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 5,
    fill: "#ECE6FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_229_125)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.9931 24.8715C34.9931 25.4965 34.4722 25.9861 33.8819 25.9861H32.7708L32.7951 31.5486C32.8021 32.7812 31.8056 33.7812 30.5729 33.7812H19.4479C18.2222 33.7812 17.2257 32.7847 17.2257 31.559V25.9861H16.1111C15.4861 25.9861 15 25.5 15 24.8715C15 24.559 15.1042 24.2812 15.3472 24.0382L24.25 16.2778C24.4931 16.0347 24.7708 16 25.0139 16C25.2569 16 25.5347 16.0694 25.7431 16.2431L29.4444 19.4965V18.2222C29.4444 17.6076 29.941 17.1111 30.5556 17.1111H31.6667C32.2812 17.1111 32.7778 17.6076 32.7778 18.2222V22.4236L34.6111 24.0347C34.8889 24.2778 35.0278 24.5556 34.9931 24.8681V24.8715ZM24.4444 22.6667C24.1389 22.6667 23.8889 22.9167 23.8889 23.2222V24.8889H22.2222C21.9167 24.8889 21.6667 25.1389 21.6667 25.4444V26.5556C21.6667 26.8611 21.9167 27.1111 22.2222 27.1111H23.8889V28.7778C23.8889 29.0833 24.1389 29.3333 24.4444 29.3333H25.5556C25.8611 29.3333 26.1111 29.0833 26.1111 28.7778V27.1111H27.7778C28.0833 27.1111 28.3333 26.8611 28.3333 26.5556V25.4444C28.3333 25.1389 28.0833 24.8889 27.7778 24.8889H26.1111V23.2222C26.1111 22.9167 25.8611 22.6667 25.5556 22.6667H24.4444Z",
    fill: "#805EED"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_229_125"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 17.7778,
    fill: "white",
    transform: "translate(15 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurplehouse);
export default __webpack_public_path__ + "static/media/purplehouse.b1614da8d6e155c61acb7ae7c6bc1ec2.svg";
export { ForwardRef as ReactComponent };